<app-status-bar></app-status-bar>
<div class="wrapper w-100 pass-sale-bulk-wrapper" [class.panel-collapsed]="panelCollapsed">

    <!-- SUCCESS OVERLAY -->
    <div class="pass-success-overlay" *ngIf="passAdded">
        <div class="pass-success-card">
            <div class="success-icon">
                <fa-icon [icon]="faCircleCheck"></fa-icon>
            </div>
            <h2 class="success-title">¡{{ quantity }} abono{{ quantity > 1 ? 's' : '' }} añadido{{ quantity > 1 ? 's' : '' }}!</h2>
            <p class="success-pass-name" *ngIf="pass">{{ pass.name }}</p>
            <div class="success-actions">
                <button class="btn-success-primary" routerLink="/home">
                    <fa-icon [icon]="faPlus"></fa-icon>
                    <span>Más entradas</span>
                </button>
                <button class="btn-success-secondary" routerLink="/passes">
                    <fa-icon [icon]="faTicket"></fa-icon>
                    <span>Añadir otro abono</span>
                </button>
            </div>
        </div>
    </div>

    <!-- SELECTION FLOW -->
    <div class="pass-layout">

        <!-- Left sidebar -->
        <div class="pass-sidebar">
            <div class="pass-sidebar-scroll" [class.picker-open]="openDatePicker">
                <div class="go-back" (click)="goBack()">
                    <i class="fa-sharp fa-thin fa-arrow-left"></i>
                    <span>Abonos</span>
                </div>

                <div *ngIf="loading" class="loading-spinner">
                    <mat-progress-spinner color="accent" mode="indeterminate" diameter="30">
                    </mat-progress-spinner>
                </div>

                <ng-container *ngIf="!loading && pass">
                    <div class="pass-sidebar-header">
                        <div class="pass-sidebar-name">{{ pass.name }}</div>
                    </div>

                    <!-- Progress info -->
                    <div class="pass-progress-bar">
                        <span>{{ getCompletedEventsCount() }}/{{ getMinEvents() }} eventos</span>
                        <div class="filter-toggle" (click)="toggleFilters()"
                            [class.active]="filtersOpen || hasActiveFilters()">
                            <fa-icon [icon]="faSliders"></fa-icon>
                        </div>
                    </div>

                    <!-- Collapsible filters -->
                    <div class="pass-filters" *ngIf="filtersOpen">
                        <div class="pass-filter-search">
                            <i class="fal fa-search"></i>
                            <input type="text" [value]="searchText"
                                (input)="onSearchChange($any($event.target).value)"
                                placeholder="Buscar evento">
                        </div>

                        <div class="pass-filter-date" #fechaDropdown>
                            <div class="date-filter-trigger" (click)="openDatePicker=!openDatePicker"
                                [class.active]="fromDate">
                                <i class="fal fa-calendar"></i>
                                <span class="date-label" *ngIf="!stringDate">Fecha</span>
                                <span class="date-label" *ngIf="stringDate">{{ stringDate }}</span>
                                <i class="fal fa-angle-down arrow-icon"></i>
                            </div>
                            <div class="calendar-dropdown" *ngIf="openDatePicker">
                                <ngb-datepicker class="custom-datepicker-event" #dp [displayMonths]="1"
                                    [dayTemplate]="t" outsideDays="visible" (dateSelect)="changeDate($event)"
                                    [minDate]="minDate" (navigate)="dateNavigate($event)">
                                    <ng-template #t let-date let-focused="focused">
                                        <span class="custom-day"
                                            [class.focused]="fromDate != null && hoveredDate != null"
                                            [class.first-select]="isFromDate(date)"
                                            [class.last-select]="isToDate(date)"
                                            [class.faded]="isHovered(date) || isInside(date)"
                                            [class.border-monday]="isMonday(date)"
                                            [class.border-sunday]="isSunday(date)"
                                            [class.range]="isRange(date)"
                                            [class.day-disabled]="isDisabled(date)"
                                            (mouseenter)="hoveredDate = date"
                                            (mouseleave)="hoveredDate = null">
                                            <span class="inside-day"
                                                [class.weekend]="isWeekend(date)">{{ date.day }}</span>
                                        </span>
                                    </ng-template>
                                </ngb-datepicker>
                            </div>
                        </div>

                        <div class="btn-clear-filter" (click)="clearFilters()" *ngIf="hasActiveFilters()">
                            <fa-icon [icon]="faTimes"></fa-icon>
                            <span>Limpiar</span>
                        </div>
                    </div>

                    <!-- Event list -->
                    <div class="pass-event-list" *ngIf="getFilteredPassItems().length">
                        <div class="pass-event-item"
                            *ngFor="let item of getFilteredPassItems()"
                            [class.current]="isCurrentEvent(getEvent(item).id)"
                            [class.completed]="isEventCompleted(getEvent(item).id)"
                            (click)="selectEvent(item)">
                            <fa-icon [icon]="faCheck" class="event-check"
                                [class.done]="isEventCompleted(getEvent(item).id)">
                            </fa-icon>
                            <div class="event-info">
                                <span class="event-name">{{ getEvent(item).title }}</span>
                                <span class="event-date" *ngIf="getEvent(item).start_date">
                                    {{ getEvent(item).start_date | date: 'dd MMM yyyy · HH:mm':'+0000' }}h
                                </span>
                                <span class="event-seats-progress"
                                    *ngIf="getEventSelectionCount(getEvent(item).id) > 0">
                                    {{ getEventSelectionCount(getEvent(item).id) }}/{{ quantity }} butacas
                                </span>
                                <span class="event-type" *ngIf="hasMap(item) && getEventSelectionCount(getEvent(item).id) === 0">
                                    <fa-icon [icon]="faChair"></fa-icon> Con mapa
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- Add pass to cart button -->
                    <button class="btn-add-pass"
                        *ngIf="allEventsCompleted()"
                        [disabled]="submitting"
                        (click)="addPassToCart()">
                        <fa-icon [icon]="faTicket"></fa-icon>
                        <span *ngIf="!submitting">Añadir {{ quantity }} abono{{ quantity > 1 ? 's' : '' }}</span>
                        <span *ngIf="submitting">Añadiendo...</span>
                    </button>
                </ng-container>
            </div>
        </div>

        <!-- Center: seat-map in pass mode -->
        <div class="pass-center">
            <app-seat-map *ngIf="currentEventId"
                [passMode]="true"
                [fixedPricePass]="isFixedPrices() ? pass : null"
                [passMaxSeats]="quantity"
                [passSelectedCount]="(eventSelections.get(currentEventId) || []).length"
                [passPreselectedSeatIds]="getPreselectedSeatIds(currentEventId)"
                [allowedSessionIds]="currentAllowedSessionIds"
                (passSelection)="onEventSelection($event)">
            </app-seat-map>
        </div>

        <!-- Right panel: bulk selections preview -->
        <div class="cart-panel" style="margin-top: 80px;">
            <button class="cart-toggle-btn" (click)="togglePanel()" [title]="panelCollapsed ? 'Mostrar resumen' : 'Ocultar resumen'">
                <span class="cart-icon-wrap">
                    <fa-icon [icon]="faTicket"></fa-icon>
                    <span class="cart-toggle-badge" *ngIf="getCompletedEventsCount() > 0">{{ getCompletedEventsCount() }}</span>
                </span>
                <i class="cart-toggle-chevron fa-light" [class.fa-chevron-right]="!panelCollapsed" [class.fa-chevron-left]="panelCollapsed"></i>
            </button>
            <div class="cart-panel-inner" [class.panel-inner-collapsed]="panelCollapsed">
            <div class="pass-selections-panel">
                <div class="pass-selections-scroll">
                    <div class="pass-selections-header">
                        <div>
                            <p class="pass-selections-title">Abono grupal</p>
                            <p class="pass-selections-subtitle" *ngIf="pass">{{ pass.name }} · {{ quantity }} personas</p>
                        </div>
                        <button class="btn-clear-all" *ngIf="eventDetailsList.length > 0" (click)="clearAllSelections()" title="Vaciar selección">
                            <fa-icon [icon]="faTrash"></fa-icon>
                            <span>Vaciar</span>
                        </button>
                    </div>

                    <div *ngIf="eventDetailsList.length > 0" class="pass-selections-list">
                        <div class="pass-selection-event-group"
                            *ngFor="let group of eventDetailsList; trackBy: trackByEventId">
                            <div class="event-group-header"
                                [class.completed]="group.completed">
                                <div class="event-group-img">
                                    <img *ngIf="group.details[0]?.eventImage"
                                        [src]="urlImages + group.details[0].eventImage" />
                                    <div class="sel-img-placeholder" *ngIf="!group.details[0]?.eventImage">
                                        <fa-icon [icon]="faCalendar"></fa-icon>
                                    </div>
                                </div>
                                <div class="event-group-info">
                                    <div class="event-group-title">{{ group.details[0]?.eventTitle }}</div>
                                    <div class="event-group-progress"
                                        [class.done]="group.completed">
                                        {{ group.details.length }}/{{ quantity }} butacas
                                        <fa-icon [icon]="faCircleCheck" *ngIf="group.completed" class="done-icon"></fa-icon>
                                    </div>
                                </div>
                                <div class="event-group-remove" (click)="removeSelection(group.eventId)">
                                    <fa-icon [icon]="faTrash"></fa-icon>
                                </div>
                            </div>

                            <!-- Individual slots -->
                            <div class="event-group-slots">
                                <div class="event-slot" *ngFor="let detail of group.details">
                                    <span class="slot-seat" *ngIf="detail.seatRow || detail.seatSeat || detail.seatSection">
                                        <span class="slot-seat-section">
                                            <fa-icon [icon]="faChair"></fa-icon>
                                            <span *ngIf="detail.seatSection">{{ detail.seatSection }}</span>
                                        </span>
                                        <span class="slot-seat-detail" *ngIf="detail.seatRow || detail.seatSeat">
                                            <span *ngIf="detail.seatRow">Fila: {{ detail.seatRow }}</span>
                                            <span class="slot-seat-sep" *ngIf="detail.seatRow && detail.seatSeat">·</span>
                                            <span *ngIf="detail.seatSeat">Butaca: {{ detail.seatSeat }}</span>
                                        </span>
                                    </span>
                                    <span class="slot-ticket" *ngIf="!detail.seatRow && !detail.seatSeat && !detail.seatSection">{{ detail.ticketName }}</span>
                                    <span class="slot-ticket" *ngIf="isFixedPrices() && detail.ticketPrice != null">{{ detail.ticketPrice | number:'1.2-2' }} €</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="getEventDetailsList().length === 0" class="pass-selections-empty">
                        <fa-icon [icon]="faUsers" class="empty-icon"></fa-icon>
                        <p>Selecciona {{ quantity }} butaca{{ quantity > 1 ? 's' : '' }} para cada evento del abono</p>
                    </div>
                </div>

                <!-- Bottom -->
                <div class="pass-selections-bottom">
                    <div class="pass-selections-count">
                        {{ getCompletedEventsCount() }}/{{ getMinEvents() }} eventos · {{ quantity }} personas
                        <ng-container *ngIf="isFixedPrices() && getCompletedEventsCount() > 0"> · {{ getSelectionsTotal() | number:'1.2-2' }} €</ng-container>
                    </div>
                    <button class="btn-add-pass-bottom"
                        [disabled]="!allEventsCompleted() || submitting"
                        (click)="addPassToCart()">
                        <span *ngIf="!submitting">AÑADIR {{ quantity }} ABONO{{ quantity > 1 ? 'S' : '' }}</span>
                        <span *ngIf="submitting">AÑADIENDO...</span>
                    </button>
                </div>
            </div>
            </div>
        </div>
    </div>
</div>
